export default __webpack_public_path__ + "assets/calendar-component.cf49313a.svg";